// theme/scripts/common/option.js

import React, { useContext, useEffect, useRef } from 'react';
import { CustomizeContext } from "../contexts/customize";

const Option = ({ cleric, ind, name, parent }) => {
  const { customizes, setCustomizesForce } = useContext(CustomizeContext);
  const prevParentValue = useRef(customizes[parent]?.value);

  const eq = (a, b) =>
    String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase();

  useEffect(() => {
    const currentParentValue = customizes[parent]?.value;

    if (
      prevParentValue.current &&
      currentParentValue &&
      prevParentValue.current !== currentParentValue
    ) {
      console.log(`🔄 parent "${parent}" changed → reset ${name}`);
      setCustomizesForce((prev) => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [name]: { id: '', label: '', value: '' },
        },
      }));
    }

    prevParentValue.current = currentParentValue;
  }, [customizes[parent].value]);

  const optionClick = (e) => {
    e.stopPropagation();

    setCustomizesForce((prev) => {
      const current = prev[parent]?.[name];

      const isSame =
        current &&
        !Array.isArray(current) &&
        (eq(current.value, cleric.value) || eq(current.label, cleric.label));

      const updatedValue = isSame
        ? { id: '', label: '', value: '' }
        : { ...cleric };

      console.log(
        `${isSame ? '❌' : '✅'} ${parent}.${name} ${isSame ? 'deselected' : 'selected'}:`,
        cleric.label
      );

      return {
        ...prev,
        [parent]: {
          ...prev[parent],
          [name]: updatedValue,
        },
      };
    });
  };

  const current = customizes[parent]?.[name];
  const currentVal = current && !Array.isArray(current) ? current.value : '';
  const currentLabel = current && !Array.isArray(current) ? current.label : '';
  const isChecked = eq(currentVal, cleric.value) || eq(currentLabel, cleric.label);

  return (
    <div
      className={`options-item__type selects-item${isChecked ? ' active' : ''}`}
      onClick={optionClick}
      data-id={cleric.id}
      data-label={cleric.label}
      data-value={cleric.value}
    >
      <div className={`options-item__type__button${isChecked ? ' checked' : ''}`} />
      <p className="options-item__type__label">{cleric.label}</p>
      <p className="options-item__type__description">{cleric.description}</p>
    </div>
  );
};

export default Option;
